import css from 'styled-jsx/css';
import { isRTL } from 'common/styling/theme';

const staticStyles = css`
  @import 'src/common/styling/_mixins-scss/screen-size';
  @import 'src/common/styling/_mixins-scss/rem';

  .LpaTransferForm {
    &__step {
      font-size: rem(26px);
      margin-bottom: rem(30px);
      margin-top: rem(50px);
      font-weight: 300;
    }

    &__content {
      display: flex;
      flex-direction: column;
    }

    &__btns {
      :global(.DefaultButton:last-child) {
        margin-left: rem(${isRTL ? '0' : '20px'});
        margin-right: rem(${isRTL ? '20px' : '0'});
      }
    }
  }
`;

export { staticStyles };
